import { render, staticRenderFns } from "./ContactCrmInfo.vue?vue&type=template&id=79d40027&scoped=true&"
import script from "./ContactCrmInfo.vue?vue&type=script&lang=js&"
export * from "./ContactCrmInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContactCrmInfo.vue?vue&type=style&index=0&id=79d40027&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d40027",
  null
  
)

export default component.exports